// stores/schedule-member-store.js
import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/config/api";
import { withShioriAccessContext } from "@/api/shiori-access-context.js";

export const useScheduleMemberStore = defineStore("scheduleMember", {
  state: () => ({
    scheduleMembers: [],
    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchScheduleMembers(shioriId, scheduleId) {
      this.isLoading = true;
      this.error = null;
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_URL}/schedule_member/?shiori_id=${shioriId}&schedule_id=${scheduleId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        this.scheduleMembers = response.data;
        return response.data;
      } catch (err) {
        this.error = err;
        console.error("スケジュールメンバー取得エラー:", err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },

    async createScheduleMember(memberData) {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${API_URL}/schedule_member/`,
          memberData,
          withShioriAccessContext(
            memberData.shioriId || memberData.shiori_id,
            {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            },
          ),
        );
        return response.data;
      } catch (err) {
        console.error("スケジュールメンバー作成エラー:", err);
        throw err;
      }
    },

    async updateScheduleMember(shioriId, scheduleId, memberCode, updateData) {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.put(
          `${API_URL}/schedule_member/?shiori_id=${shioriId}&schedule_id=${scheduleId}&member_code=${memberCode}`,
          updateData,
          withShioriAccessContext(shioriId, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        );
        return response.data;
      } catch (err) {
        console.error("スケジュールメンバー更新エラー:", err);
        throw err;
      }
    },

    async deleteScheduleMember(shioriId, scheduleId, memberCode) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(
          `${API_URL}/schedule_member/?shiori_id=${shioriId}&schedule_id=${scheduleId}&member_code=${memberCode}`,
          withShioriAccessContext(shioriId, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        );
      } catch (err) {
        console.error("スケジュールメンバー削除エラー:", err);
        throw err;
      }
    },
  },
});
